export function fixEncoding(text) {
  if (!text) return "";

  const replacements = {
    Åƒ: "Ń",

    "Å„": "ń",

    Åš: "Ś",
    "Å¼": "ż",
    "Å›": "ś",

    "Å‚": "ł",
    "Ä™": "ę",
    "Ä‡": "ć",
    "Ä…": "ą",
    "Ä„": "Ą",
    "Ä†": "Ć",
    "Ä˜": "Ę",
    "Å": "Ł",

    "Å»": "Ż",
    "Ã³": "ó",
    "Ã“": "Ó",
    "Å¹": "Ź",
    Åº: "ź",
    "Å’": "œ",
    "Å½": "Ž",
  };

  for (const [key, value] of Object.entries(replacements)) {
    try {
      text = text.replaceAll(key, value);
    } catch (error) {
      console.log(error);
    }
  }
  if (!text) return "";
  return text;
}
